import React, { useEffect, useState } from 'react'
import { KPIController } from '../../hooks/useKPI'
import { Typography } from '@material-ui/core'
import { Container } from '../../components'
import Plot from 'react-plotly.js'

interface EZManageProps {
    KPIController: KPIController
}
export const EZManage = ({ KPIController }: EZManageProps) => {
    const { ezManage } = KPIController
    const [plotWidth, setPlotWidth] = useState(0)
    const [plotHeight, setPlotHeight] = useState(0)

    useEffect(() => {
        KPIController.getEzManage()
    }, [])

    useEffect(() => {
        const updateDimensions = () => {
            const container = document.querySelector('.plot-container')
            if (container) {
                setPlotWidth(container.clientWidth - 20)
                setPlotHeight(container.clientHeight - 20)
            }
        }
        updateDimensions()
        window.addEventListener('resize', updateDimensions)
        return () => window.removeEventListener('resize', updateDimensions)
    }, [])

    const xValues = (ezManage ?? []).map((row) => row.apartment_name)
    const yValues = (ezManage ?? []).map((row) => row.tokens)

    return (
        <Container
            style={{
                flex: 1,
                flexDirection: 'column',
                height: 'calc(100vh - 200px)',
            }}
            className="plot-container"
        >
            <Typography variant="h6">EZ Manage</Typography>
            <Plot
                data={[
                    {
                        type: 'bar',
                        x: xValues,
                        y: yValues,
                    },
                ]}
                layout={{
                    width: plotWidth,
                    height: plotHeight,
                    margin: { t: 40, r: 20, l: 50, b: 80 },
                    xaxis: { title: 'Apartment' },
                    yaxis: { title: 'Tokens' },
                }}
                config={{ responsive: true, displayModeBar: false }}
            />
        </Container>
    )
}
